import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * Contractul lui GET /api/v2/settings/rail (v4/api, App\Settings\Rail\SettingsRail).
 *
 * Zona se alege dupa ADRESA paginii, si tot serverul spune care rand e aprins:
 * doua locuri care ghicesc pagina curenta ajung sa raspunda diferit - scrie
 * chiar asa in `_partials/settings_rail.php`.
 */
export interface SettingsRailItem {
  label: string
  /** Adresa din portal, fara `/app` (`settings/users_accounts`). */
  url: string
  icon: string
  active: boolean
}

export interface SettingsRailData {
  /** Sirul gol = adresa nu e intr-o zona de setari, deci nu se deseneaza rail. */
  zone: string
  label: string
  items: SettingsRailItem[]
}

export function settingsRailQuery(path: string) {
  return queryOptions({
    queryKey: ['settings-rail', path],
    queryFn: () => apiGet<SettingsRailData>(`/settings/rail?path=${encodeURIComponent(path)}`),
    staleTime: 5 * 60 * 1000,
  })
}
